module.exports = __webpack_public_path__ + "img/pnu_read_gallery3.215f1e42.jpg";